export const DOCUMENT_ACTION = {
  ADDED_COMMENT: "AddedComment",
  REMOVED_COMMENT: "RemovedComment",
  UPDATED: "Updated",
  UPLOADED: "Uploaded",
}
